export const TOKEN = "token";
export const ISREMEMBER = "isRemember";
export const REFRESHTOKEN = "refreshToken";

export const TOTALLIMIT = "10";
